export default "__VITE_ASSET__VoGFOoNC__"